<template>
  <el-container>
    <el-header>
      <Header></Header>
    </el-header>
    <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
    <img
      id="btn"
      class="callTop"
      v-if="$route.name != 'index'"
      :src="require('@/assets/image/bt_hdb.png')"
      @click="callTop()"
    ></img>
    <Footer v-if="$route.name != 'index'"></Footer>
  </el-container>
</template>

<script>
import Header from "./public/header.vue";
import Footer from "./robot/footer.vue";
export default {
  components: {
    Header,
    Footer
  },
  methods:{
    callTop(){
      document.documentElement.scrollTop = 0;
    }
  },
  mounted() {
    window.onscroll = function() {
      var btn = document.getElementById('btn');
      var scrollTop =
        document.body.scrollTop ||
        (document.documentElement && document.documentElement.scrollTop);
        // console.log(scrollTop)
      if (scrollTop < 1000) {
        btn.style.display = "none";
      } else {
        btn.style.display = "block";
      }
    };
  }
};
</script>

<style>
.hide {
  display: none;
}
.callTop {
  z-index: 3000;
  cursor: pointer;
  position: fixed;
  bottom: 194px;
  right: 10px;
  width: 70px;
  height: 70px;
}
.el-container {
  width: 100%;
  height: 100%;
}
.el-container .el-header {
  padding: 0;
  width: inherit;
  position: absolute;
  z-index: 20;
}

@media screen and (max-width: 1280px) {
  .el-container {
    width: 1280px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue